import React from 'react';
import { LinkedinIcon, InstagramIcon, ArrowUpIcon, PhoneIcon, MapPinIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-tlfc-dark pt-16 pb-8" data-id="element-109">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-110">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-111">
          {/* Column 1 - Brand */}
          <div data-id="element-112">
            <div className="flex items-center gap-1.5" data-id="element-113">
              <span className="text-base font-semibold tracking-wide text-tlfc-white" data-id="element-114">
                Tisher Liner
              </span>
              <span className="text-base font-light tracking-wide text-white/60" data-id="element-115">
                FC Law
              </span>
            </div>
            <p className="mt-4 text-sm text-white/50 leading-relaxed" data-id="element-116">
              Melbourne's trusted legal team. Delivering clarity and results for
              over 50 years.
            </p>
            <div className="flex items-center gap-4 mt-6" data-id="element-117">
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:bg-white/20 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-118">
                <LinkedinIcon className="w-4 h-4" aria-hidden="true" data-id="element-119" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:bg-white/20 hover:text-white transition-colors" aria-label="Instagram" data-id="element-120">
                <InstagramIcon className="w-4 h-4" aria-hidden="true" data-id="element-121" />
              </a>
            </div>
          </div>

          {/* Column 2 - Expertise */}
          <div data-id="element-122">
            <h3 className="text-sm font-medium text-tlfc-white mb-5" data-id="element-123">
              Expertise
            </h3>
            <ul className="space-y-3" data-id="element-124">
              <li data-id="element-125">
                <a href="#" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-126">
                  Property & Development
                </a>
              </li>
              <li data-id="element-127">
                <a href="#" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-128">
                  Litigation & Disputes
                </a>
              </li>
              <li data-id="element-129">
                <a href="#" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-130">
                  Commercial Law
                </a>
              </li>
              <li data-id="element-131">
                <a href="#" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-132">
                  Employment Law
                </a>
              </li>
              <li data-id="element-133">
                <a href="#" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-134">
                  Family Law
                </a>
              </li>
              <li data-id="element-135">
                <a href="#" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-136">
                  Owners Corporations
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Firm */}
          <div data-id="element-137">
            <h3 className="text-sm font-medium text-tlfc-white mb-5" data-id="element-138">Firm</h3>
            <ul className="space-y-3" data-id="element-139">
              <li data-id="element-140">
                <a href="#about" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-141">
                  About
                </a>
              </li>
              <li data-id="element-142">
                <a href="#people" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-143">
                  Our People
                </a>
              </li>
              <li data-id="element-144">
                <a href="#insights" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-145">
                  Insights
                </a>
              </li>
              <li data-id="element-146">
                <a href="#start-online" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-147">
                  Start Online
                </a>
              </li>
              <li data-id="element-148">
                <a href="#" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-149">
                  Payments
                </a>
              </li>
              <li data-id="element-150">
                <a href="#contact" className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-151">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div data-id="element-152">
            <h3 className="text-sm font-medium text-tlfc-white mb-5" data-id="element-153">
              Contact
            </h3>
            <div className="space-y-4" data-id="element-154">
              <a href="tel:0386009333" className="flex items-center gap-3 text-sm text-white/50 hover:text-white transition-colors" data-id="element-155">
                <PhoneIcon className="w-4 h-4 text-tlfc-gold" aria-hidden="true" data-id="element-156" />
                (03) 8600 9333
              </a>
              <a href="mailto:info@tlfc.com.au" className="flex items-center gap-3 text-sm text-white/50 hover:text-white transition-colors" data-id="element-157">
                <MailIcon className="w-4 h-4 text-tlfc-gold" aria-hidden="true" data-id="element-158" />
                info@tlfc.com.au
              </a>
              <div className="flex items-start gap-3 text-sm text-white/50" data-id="element-159">
                <MapPinIcon className="w-4 h-4 text-tlfc-gold flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-160" />
                <address className="not-italic leading-relaxed" data-id="element-161">
                  Level 6, Bourke Place,
                  <br data-id="element-162" />
                  600 Bourke Street,
                  <br data-id="element-163" />
                  Melbourne VIC 3000
                </address>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-8 border-t border-white/10" data-id="element-164">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-165">
            <p className="text-xs text-white/40" data-id="element-166">
              © 2026 Tisher Liner FC Law. All rights reserved.
            </p>

            <div className="flex items-center gap-6 text-xs text-white/40" data-id="element-167">
              <a href="#" className="hover:text-white transition-colors" data-id="element-168">
                Terms
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-169">
                Privacy
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-170">
                Accessibility
              </a>
            </div>

            <button onClick={scrollToTop} className="flex items-center gap-2 text-xs text-white/40 hover:text-white transition-colors group" aria-label="Back to top" data-id="element-171">
              <span data-id="element-172">Back to top</span>
              <ArrowUpIcon className="w-4 h-4 transition-transform group-hover:-translate-y-1" aria-hidden="true" data-id="element-173" />
            </button>
          </div>
        </div>
      </div>
    </footer>;
}